'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function now() {
    return Date.now();
}

exports.now = now;
